import { useEffect } from "react";
import { useState } from "react";

import { useSelector, useDispatch } from "react-redux";
import { alertAction } from "../../store/alert-store";

import "./alert.css";
const Alert = (props) => {
  const dispatch = useDispatch();
  const action = useSelector((state) => state.alert.action);
  const alert_class = useSelector((state) => state.alert.alert_class);
  const alert_icon = useSelector((state) => state.alert.alert_icon);
  const alert_txt = useSelector((state) => state.alert.alert_txt);

  const [alert, setAlert] = useState(action);
  const [showAlert, setShowAlert] = useState();
  useEffect(() => {
    if (action === "show") {
      setAlert(action);
      // setAlert("hide");
      // alert && setAlert("hide");
      setShowAlert("showAlert");

      setTimeout(function () {
        setAlert("hide");
        dispatch(
          alertAction.showAlert({
            action: "hide",
            alert_txt: "",
            alert_class: "danger",
          })
        );
      }, 5000);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [action]);

  const hideAlert = () => {
    setAlert("hide");

    dispatch(
      alertAction.showAlert({
        action: "hide",
        alert_txt: "",
        alert_class: "danger",
      })
    );
  };

  // console.log(action);

  return (
    <>
      {alert_txt.trim() !== "" && (
        <div className={`alert ${showAlert}  bg-${alert_class} ${alert}  `}>
          <span className={`fas ${alert_icon}`}></span>
          <span className="msg">{alert_txt}</span>
          <div className="close-btn" onClick={hideAlert}>
            <span className="fas fa-times"></span>
          </div>
        </div>
      )}
    </>
  );
};

export default Alert;
